import { render, staticRenderFns } from "./PuzzleSelectOptionModal.vue?vue&type=template&id=2e4812f7&scoped=true&"
import script from "./PuzzleSelectOptionModal.vue?vue&type=script&lang=js&"
export * from "./PuzzleSelectOptionModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzzleSelectOptionModal.vue?vue&type=style&index=0&id=2e4812f7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4812f7",
  null
  
)

export default component.exports